import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';
import { constant } from 'lodash-es';

import { getQueryParams } from '../../utils/utils';
import { LogService } from '../log-service';
import { AuthenticationService } from './authentication.service';
import { LogMessageType } from '@se/se.platform.base';

export const WebLoginInitializer: Provider | EnvironmentProviders = provideAppInitializer(() => {
        const initializerFn = (externalLogin)(inject(AuthenticationService), inject(LogService));
        return initializerFn();
      });

export function externalLogin(authenticationService: AuthenticationService, logger: LogService) {
    return async () => {
        const queryParams = getQueryParams();

        return authenticationService
            .estensaWebLogin(queryParams.token)
            .catch(err => logger.log(LogMessageType.Error, err.message).finally(constant(false)))
            .then(isAuthenticated => {
                // In caso l'autenticazione fallisse, logga l'errore e chiudi la finestra.
                if (!isAuthenticated) {
                    return logger
                        .log(LogMessageType.Fatal, '[SeModulesTeleconsultation]: Estensa Web Login Failed.')
                        .finally(() => window.close());
                }
            });
    };
}
